<template>
  <v-app id="app" class="app" v-show="!$root.platform.prerenderer && isReady">

    <v-main>
      <transition
        name="fade"
      >
        <router-view v-if="isReady" />
      </transition>
    </v-main>

    <!--<VersionInfo
      v-if="$root.process.env.SERVICE_STAGE !== 'production'"
      :version="$root.process.env.GIT_VERSION"
      :commit-hash="$root.process.env.GIT_COMMIT_HASH"
      />-->

    <Footer v-if="isReady && $root.loggedIn"></Footer>
  </v-app>
</template>

<script>
import Footer from './organisms/Footer.vue'
// import VersionInfo from '@monogrid/vue-lib/lib/components/VersionInfo'
import shareImage from '@/assets/img/share.jpg'

import coats from '@/assets/data/collection/coats.json'
import crochet from '@/assets/data/collection/crochet.json'
import dress from '@/assets/data/collection/dress.json'
import knitwear from '@/assets/data/collection/knitwear.json'
import pyjamas from '@/assets/data/collection/pyjamas.json'
import swiss from '@/assets/data/collection/swiss.json'
import accessories from '@/assets/data/collection/accessories.json'

import women24coats from '@/assets/data/collection-women-2024/women24-coats.json'
import women24crochet from '@/assets/data/collection-women-2024/women24-crochet.json'
import women24dress from '@/assets/data/collection-women-2024/women24-dress.json'
import women24knitwear from '@/assets/data/collection-women-2024/women24-knitwear.json'
import women24pyjamas from '@/assets/data/collection-women-2024/women24-pyjamas.json'
import women24topbottom from '@/assets/data/collection-women-2024/women24-topbottom.json'
import women24accessories from '@/assets/data/collection-women-2024/women24-accessories.json'
import women24sleepwear from '@/assets/data/collection-women-2024/women24-sleepwear.json'

import mencapes from '@/assets/data/collection-men/men-capes.json'
import menjackets from '@/assets/data/collection-men/men-jackets.json'
import menknitwear from '@/assets/data/collection-men/men-knitwear.json'
import menshirts from '@/assets/data/collection-men/men-shirts.json'
import menkaftans from '@/assets/data/collection-men/men-kaftans.json'
import menaccessories from '@/assets/data/collection-men/men-accessories.json'

let initializedModernizr = false
export default {
  name: 'App',

  components: {
    Footer
    // VersionInfo
  },

  data: function () {
    return {
      // this flag is used to show the app once the preloading
      // (if present) is finished
      isReady: false
    }
  },

  mounted: function () {
    // set this.isReady = true
    // when all stuff that needs to be loaded for the app is loaded
    // if you need to preload stuff, delete this line and set to true later
    this.$root.config.collection = [
      coats,
      dress,
      pyjamas,
      knitwear,
      crochet,
      swiss,
      accessories,
      women24coats,
      women24dress,
      women24pyjamas,
      women24knitwear,
      women24crochet,
      women24topbottom,
      women24accessories,
      women24sleepwear,
      mencapes,
      menjackets,
      menknitwear,
      menshirts,
      menkaftans,
      menaccessories
    ]
    this.$root.config.collectionwomen = [
      coats,
      pyjamas,
      crochet,
      knitwear,
      dress,
      swiss,
      accessories
    ]
    this.$root.config.collectionwomen24 = [
      women24coats,
      women24pyjamas,
      women24crochet,
      women24knitwear,
      women24dress,
      women24topbottom,
      women24sleepwear,
      women24accessories
    ]
    this.$root.config.collectionmen = [
      mencapes,
      menjackets,
      menknitwear,
      menshirts,
      menkaftans,
      menaccessories
    ]
    this.isReady = true
  },

  updated () {
    // if not prerenderer
    if (!this.$root.platform.prerenderer && window.Modernizr && !initializedModernizr) {
      // add custom modernizr tests
      initializedModernizr = true
      // window.Modernizr.addAsyncTest('avif', this.testAvif)
      for (const key in this.$root.platform) {
        window.Modernizr.addTest(key, () => {
          return this.$root.platform[key]
        })
      }
    }
  },
  watch: {

    isReady: function (value) {
      // hide / show preloader
      this.$root.preloader.visible = !value
    }
  },

  metaInfo: function () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: ' ',
      // all titles will be injected into this template
      titleTemplate: '%s | lokomotive',
      base: { href: '/' },
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
        { name: 'mobile-web-app-capable', content: 'yes' },
        // twitter
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@lokomotiveooo' },
        { name: 'twitter:creator', content: '@lokomotiveooo' },
        // generic description
        { vmid: 'description', name: 'description', content: 'lokomotive website' },
        // og tags
        { vmid: 'ogtype', property: 'og:type', content: 'website' },
        { vmid: 'ogurl', property: 'og:url', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + '/' + this.$route.fullPath },
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: 'lokomotive' },
        { vmid: 'ogdescription', property: 'og:description', content: 'lokomotive website' },
        { vmid: 'ogimage', property: 'og:image', content: 'https://' + this.$root.process.env.SERVICE_TARGET_DOMAIN + shareImage },
        { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
        { vmid: 'ogimageheight', property: 'og:image:width', content: '1200' },
        { vmid: 'ogimagewidth', property: 'og:image:height', content: '630' }
      ]
    }
  }
}
</script>

<style lang="scss">

/*
@font-face {
  font-family: 'Bosch';
  src: url('./assets/fonts/Bosch.woff') format('woff');
}*/

@font-face {
  font-family: 'Cotta';
  src: url('./assets/fonts/Cotta-Free.woff') format('woff');
}
/*
@font-face {
  font-family: 'Harmond';
  src: url('./assets/fonts/Harmond-SemiBoldCondensed.woff') format('woff');
} */

.v-application {
  // font-family: 'Jost' !important;
  font-family: 'Cotta' !important;
}

.font-jost {
  // font-family: 'Jost';
  font-family: 'Cotta';
  letter-spacing: 5px;
  font-weight: 400;

  &.bold {
    font-weight: 500;
  }
}

.font-kristi {
  // font-family: 'Mr Bedfort';
  //font-family: 'Meddon';
  // font-family: 'Petit Formal Script';
  // font-family: 'Literata';
  font-family: 'Cotta';
  // font-weight: 500;
  // font-style: italic;
  // text-transform: capitalize;
  text-transform: uppercase;
}

p {
  font-size: 14px !important;
  line-height: 2;

  &.font-kristi {
    // font-size: 18px !important;
    // line-height: 30px;
  }
}

h1 {
  font-size: 96px;

  @include breakpoint('xs-only') {
    font-size: 64px;
    line-height: 1;
  }
}

h2 {
  font-size: 64px;

  @include breakpoint('xs-only') {
    font-size: 48px;
  }

  &.font-jost {
    letter-spacing: 10px;
  }
}

h3 {
  font-size: 48px;

  @include breakpoint('xs-only') {
    font-size: 30px;
  }

  &.font-jost {
    letter-spacing: 10px;
  }
}

h4 {
  font-size: 30px;

  @include breakpoint('xs-only') {
    font-size: 24px;
  }

  &.font-kristi {
    line-height: 1;
    letter-spacing: 1px;
  }
}

h5 {
  font-size: 18px;

  @include breakpoint('xs-only') {
    font-size: 12px;
  }
}

.red-bg {
  background-color: $c-red;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  transform: skew(-15deg, 0deg);
}

.white-bg {
  background-color: $c-white;
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  transform: skew(-15deg, 0deg);
}

.yellow-bg {
  background-color: $c-yellow;
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  transform: skew(-15deg, 0deg);
}

.white-box {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0.5) 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150vh;
}

.black-box {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150vh;
}

.title-drop-shadow {
  filter: drop-shadow(2px 2px 0 $c-yellow);
  text-shadow:
    1px 1px 0 $c-yellow,
    -1px 1px 0 $c-yellow,
    -1px -1px 0 $c-yellow,
    1px -1px 0 $c-yellow;
}

.c-red {
  color: $c-red;
}

.text-align-center {
  text-align: center;
}

.main-logo {
  width: 300px;
  height: auto;

  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  // background-color: $c-white;

  &.relative {
    position: relative;
    margin: auto;
    top: auto;
    left: 50%;
  }

  &.nobg {
    background-color: transparent;
  }
}

.pointer {
  cursor: pointer;
}

.icon-close {
  width: 40px;
  height: 40px;

  stroke: $c-red;
  stroke-width: 5px;

  cursor: pointer;
  transition: transform 0.25s;

  &:hover {
    transform: scale(1.1) rotate(90deg);
  }
}

.monogrid-logo-svg {
  height: 40px;
  width: 167px;

  @include breakpoint('xs-only') {
    height: 20px;
    width: 83px;
  }

  path {
    fill: map-get($shades, 'white');
    stroke: map-get($shades, 'white');
  }
}

.bg-fixed-100 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
}

.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.password {
  z-index: 2;
  background-color: $c-red;
  color: #fff;

  input {
    border: 1px solid #fff;
    border-radius: 5px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
